import axios from 'axios';
import { useQuery } from 'react-query';
import { Stack } from '../../shared/layouts';
import Loader from '../../shared/Loader';
import Header from '../../shared/Header';
import { t } from 'i18next';
import SearchInput from '../../shared/SearchInput';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@dnhb/node_package';
import useIconLibrary from '../../../hooks/useIconLibrary';
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import InsuranceRow from './InsuranceRow';

export default () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchText, setSearchText] = useState('');
  const [searchMatches, setSearchMatches] = useState([]);
  const { isLoading, data: { data: products = [] } = {} } = useQuery(
    'elements-insurances',
    async () =>
      await axios
        .get('/insurances/products')
        .catch((e) => console.error(e))
  );

  useEffect(() => {
    if (!isLoading) {
      if (location.state?.fromDetailPage && products.length === 1) {
        navigate('/dashboard');
      } else if (products.length === 1) {
        const product = products[0];
        navigate(`/products/insurances/${product.type}/${product.id}`, {
          state: { fromInsurancesList: true }
        });
      }
    }
  }, [isLoading, products, navigate, location.state]);

  const { breakpoints } = useTheme();
  const isMinDesktop = useMediaQuery(
    `(min-width: ${breakpoints.ml ?? '56.25rem'})`
  );

  const { ProductIcon } = useIconLibrary();

  const filterInsurances = (text) => {
    setSearchText(text);
    const matches = [];
    const matchConditions = (product) => {
      return ['description', 'package_number'].some((field) => {
        if (product[field]?.toUpperCase().includes(text?.toUpperCase())) {
          return true;
        }
      });
    };

    products?.filter(matchConditions).forEach((item, package_index) => {
      matches.push({ package_index, ...item });
    });

    setSearchMatches(matches);
  };

  return (
    <Stack space="xl" width={{ sm: 656, ml: 672, lg: 800, xl: 1024 }}>
      {isLoading && <Loader />}
      <Header
        title={t('Verzekeringen')}
        icon={isMinDesktop ? <ProductIcon height="2rem" width="2rem" /> : null}
        variant="page"
      />

      <SearchInput
        placeholder={t('Object of omschrijving')}
        value={searchText}
        onChange={(value) => filterInsurances(value)}
      />

      <Stack space={'m'}>
        {searchText
          ? searchMatches.map((product, index) => (
              <InsuranceRow key={index} product={product} />
            ))
          : products?.map((product, index) => (
              <InsuranceRow key={index} product={product} />
            ))}
      </Stack>
    </Stack>
  );
};
